





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { HelpCircleIcon } from 'vue-feather-icons';
import FormError from '@/components/common/forms/FormError.vue';

@Component({
  components: { FormError, HelpCircleIcon },
})
export default class FormRow extends Vue {
  @Prop({ type: String, required: true })
  name!: string;

  @Prop({ type: String, required: false })
  label!: string;

  @Prop({ type: String, required: false })
  help!: string;

  @Prop({ type: Object, required: false })
  errors!: Record<string, string[] | undefined>;

  hovered = false;

  get hasHelpSlot() {
    return !!this.$slots['help-tooltip'];
  }
}
